export default function MessageInputSkeleton() {
  return (
    <div className="px-4 py-6 animate-pulse">
      <div className="w-full flex flex-row items-end space-x-4">
        <div className="p-0.5 mb-1.5">
          <div className="size-5 rounded-full bg-zinc-100 dark:bg-zinc-800" />
        </div>
        <div className="flex grow flex-col p-px rounded-md border-0 shadow-xs bg-zinc-50 dark:bg-white/5">
          <div className="w-full rounded-t-md border-b border-transparent bg-zinc-100 dark:bg-zinc-800 dark:border-transparent h-14 px-3 py-1.5" />
          <div className="flex w-full grow flex-row items-end space-x-2 px-3 py-1.5 text-sm h-12" />
        </div>
      </div>
    </div>
  );
}
